import { useState } from "react";
import adminController from "../../../../apis/Controllers/AdminControler/admin.controller"
import wardController from "../../../../apis/Controllers/WardController/ward.controller";


export const FiltersFunctions = () => {
    const [adminsList, setAdminslist] = useState([]);
    const [wardslist, setWardsList] = useState([]);
    const [adminsSearch, setAdminsSearch] = useState("");
    const [wardsSearch, setWardsSearch] = useState("");


    const handleAssignedBySearch = (e) => {
        setAdminsSearch(e.target.value);
    };


    const handleWardsSearch = (e) => {
        setWardsSearch(e.target.value);
        getAdminsList(e.target.value);
    };


    const getAdminsList = async (e) => {
        let post  = {
            search : e  ? e : ''
        }
        let response = await adminController.adminListing(post);
        if (response && response.status) {
            setAdminslist(response.data);
        }
        else {
            setAdminslist([]);
        }
    };


    const wardsListing = async () => {
        let post  = {

        }
        let response = await wardController.wardListing();
        if (response && response.status) {
            setWardsList(response.data);
        }
        else {
            setWardsList([]);
        }
    };


    return {
        getAdminsList,
        adminsList,
        wardsListing,
        wardslist,
        adminsSearch,
        wardsSearch,
        handleWardsSearch,
        handleAssignedBySearch
    }
}